// services/msalService.js
import { loginRequest } from "../authConfig";

/**
 * Acquire access token silently or via popup fallback
 */
export async function getAccessToken(instance, accounts) {
  if (!accounts || accounts.length === 0) throw new Error("No authenticated account");
  try {
    const result = await instance.acquireTokenSilent({
      ...loginRequest,
      account: accounts[0],
    });
    return result.accessToken;
  } catch {
    const result = await instance.acquireTokenPopup(loginRequest);
    return result.accessToken;
  }
}
